/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Invite_ButtonInputs */

const en_us2_coaching_invite_button = /** @type {(inputs: Coaching_Invite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite`)
};

const pt_br2_coaching_invite_button = /** @type {(inputs: Coaching_Invite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convidar`)
};

const pt_pt2_coaching_invite_button = /** @type {(inputs: Coaching_Invite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convidar`)
};

/** @type {(inputs: Coaching_Invite_ButtonInputs) => LocalizedString} */
const es_419_coaching_invite_button = en_us2_coaching_invite_button;

/** @type {(inputs: Coaching_Invite_ButtonInputs) => LocalizedString} */
const fr_fr2_coaching_invite_button = en_us2_coaching_invite_button;

/** @type {(inputs: Coaching_Invite_ButtonInputs) => LocalizedString} */
const de_de2_coaching_invite_button = en_us2_coaching_invite_button;

/** @type {(inputs: Coaching_Invite_ButtonInputs) => LocalizedString} */
const it_it2_coaching_invite_button = en_us2_coaching_invite_button;

/**
* | output |
* | --- |
* | "Invite" |
*
* @param {Coaching_Invite_ButtonInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_invite_button = /** @type {((inputs?: Coaching_Invite_ButtonInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Invite_ButtonInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_invite_button(inputs)
	if (locale === "es-419") return es_419_coaching_invite_button(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_invite_button(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_invite_button(inputs)
	if (locale === "de-DE") return de_de2_coaching_invite_button(inputs)
	if (locale === "it-IT") return it_it2_coaching_invite_button(inputs)
	return en_us2_coaching_invite_button(inputs)
});
export { coaching_invite_button as "coaching.invite_button" }